// extracted by mini-css-extract-plugin
export var layoutContainer = "_6z-0";
export var layoutContainerNoRounding = "_6z-6";
export var layoutContainerOpen = "_6z-5";
export var layoutContainerResizing = "_6z-1";
export var mainContent = "_6z-2";
export var resizeDivider = "_6z-3";
export var slidePanel = "_6z-4";